/* eslint-disable react/jsx-key */
import { Fragment, useContext } from "react";

import { TableContext } from "../..";
import * as S from "../../styles";

const TableBody = ({ rowClick, renderRowSubComponent }) => {
  const { getTableBodyProps, page, prepareRow, visibleColumns } =
    useContext(TableContext);

  return (
    <S.TableBody {...getTableBodyProps()}>
      {page.map((row) => {
        prepareRow(row);
        return (
          <Fragment key={row.getRowProps().key}>
            <S.TableRow
              {...row.getRowProps()}
              onClick={(e) =>
                e.target.tagName !== "A" && rowClick && rowClick(row.original)
              }
              rowClick={rowClick}
            >
              {row.cells.map((cell) => {
                return (
                  <S.TableCell {...cell.getCellProps()}>
                    {cell.render("Cell")}
                  </S.TableCell>
                );
              })}
            </S.TableRow>

            {/* Sub-linha da expansão (useExpanded): ocupa todas as colunas.
                Só existe quando a tela optou por renderRowSubComponent. */}
            {renderRowSubComponent && row.isExpanded ? (
              <S.TableRow $subRow>
                <S.TableCell colSpan={visibleColumns.length}>
                  {renderRowSubComponent({ row })}
                </S.TableCell>
              </S.TableRow>
            ) : null}
          </Fragment>
        );
      })}
    </S.TableBody>
  );
};

export default TableBody;
